export default "__VITE_ASSET__DggWNddy__"